function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.025 31.229c0 .78-.255 1.402-.767 1.863-.508.46-1.2.691-2.074.691H3.758V37h-1.12v-8.256h3.475c.926 0 1.643.217 2.15.65.508.434.762 1.046.762 1.835zM7.9 31.24c0-1.066-.64-1.6-1.921-1.6H3.758v3.258h2.267c1.25 0 1.875-.552 1.875-1.658zM10.49 37v-4.863c0-.446-.011-.938-.035-1.477h.996c.031.719.047 1.15.047 1.295h.024c.168-.543.36-.914.58-1.113.218-.2.527-.299.925-.299.141 0 .284.02.428.059v.966a2.172 2.172 0 00-.562-.058c-.438 0-.772.19-1.002.568-.23.375-.346.914-.346 1.617V37H10.49zm3.967-7.688v-1.007h1.055v1.008h-1.055zm0 7.688v-6.34h1.055V37h-1.055zm6.703 0v-4.02c0-.417-.04-.742-.123-.972a.884.884 0 00-.392-.498c-.18-.102-.444-.153-.791-.153-.508 0-.909.174-1.202.522-.293.348-.44.83-.44 1.447V37h-1.054v-4.986c0-.739-.012-1.19-.035-1.354h.996c.004.02.008.072.012.158l.012.3c.007.109.015.318.023.626h.018c.242-.437.521-.746.837-.926.32-.183.717-.275 1.19-.275.695 0 1.203.174 1.523.521.325.344.487.915.487 1.711V37h-1.06zm5.092-.047c-.348.094-.703.14-1.066.14-.844 0-1.266-.478-1.266-1.435v-4.23h-.733v-.768h.774l.31-1.418h.704v1.418h1.171v.768h-1.171v4.002c0 .304.048.52.146.644.102.121.276.182.522.182.14 0 .343-.028.609-.082v.78z",
  fill: "#191919"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Print_svg__filter0_d_1087:563)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 14,
  r: 10,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 14,
  r: 9.5,
  stroke: "#D9D9D9"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.222 11.442h-1V9.556A.555.555 0 0017.667 9h-5.334a.556.556 0 00-.555.556v1.888h-1a.778.778 0 00-.778.778v3.556a.778.778 0 00.778.778h1v1.888a.556.556 0 00.555.556h5.334a.555.555 0 00.555-.556v-1.888h1a.778.778 0 00.778-.778v-3.556a.78.78 0 00-.778-.78zm-7-1.89a.11.11 0 01.111-.11h5.334a.111.111 0 01.11.11v1.89h-5.555v-1.89zm5.556 8.89a.11.11 0 01-.111.11h-5.334a.11.11 0 01-.11-.11v-3.159h5.555v3.159zm.778-5a.555.555 0 11.393-.161.556.556 0 01-.393.163v-.002z",
  fill: "#006DFF"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Print_svg__filter0_d_1087:563",
  x: 1,
  y: 0,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1087:563"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_1087:563",
  result: "shape"
})));

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgPrint;